var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveSvgrepocom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.5C11.25 14.9176 11.25 14.6264 11.3452 14.3966C11.472 14.0904 11.7154 13.847 12.0217 13.7201C12.2514 13.625 12.5426 13.625 13.125 13.625H16.875C17.4574 13.625 17.7486 13.625 17.9784 13.7201C18.2846 13.847 18.528 14.0904 18.6549 14.3966C18.75 14.6264 18.75 14.9176 18.75 15.5C18.75 16.0824 18.75 16.3736 18.6549 16.6034C18.528 16.9096 18.2846 17.153 17.9784 17.2799C17.7486 17.375 17.4574 17.375 16.875 17.375H13.125C12.5426 17.375 12.2514 17.375 12.0217 17.2799C11.7154 17.153 11.472 16.9096 11.3452 16.6034C11.25 16.3736 11.25 16.0824 11.25 15.5Z",
    stroke: "#00AFA3",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 9.25V16.75C25.625 21.464 25.625 23.8211 24.1605 25.2855C22.6961 26.75 20.339 26.75 15.625 26.75H14.375M4.375 9.25V16.75C4.375 21.464 4.375 23.8211 5.83946 25.2855C6.72042 26.1665 7.92438 26.5175 9.7701 26.6574",
    stroke: "#00AFA3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.25H5C3.82149 4.25 3.23224 4.25 2.86611 4.61611C2.5 4.98224 2.5 5.57149 2.5 6.75C2.5 7.92851 2.5 8.51776 2.86611 8.88389C3.23224 9.25 3.82149 9.25 5 9.25H25C26.1785 9.25 26.7677 9.25 27.1339 8.88389C27.5 8.51776 27.5 7.92851 27.5 6.75C27.5 5.57149 27.5 4.98224 27.1339 4.61611C26.7677 4.25 26.1785 4.25 25 4.25H20",
    stroke: "#00AFA3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveSvgrepocom);
export default __webpack_public_path__ + "static/media/archive_svgrepo.com.f8cae06ab48455dee11ff7830710c40f.svg";
export { ForwardRef as ReactComponent };